export default {
  // 查询党建大数据统计
  SEARCH_BIG_DATA_STATISTICS: "/showScreenHome/searchbasicsDataStatistics",

  // 党组织概况
  SEARCH_OVERVIEW_STATISTICS: '/showScreenHome/searchbasicsDataStatisticsThePartyProfile'
};
